import React from "react";
import OgImage from "../../assets/landingPages/homePage/Hero.png";
import HeroEllipseGroup from "../../assets/landingPages/aboutHeroEllipsGroup.png";
import useLocales from "../../hooks/useLocales";
import { Helmet } from "react-helmet";

const PrivacyPolicyPage = () => {
  const { translate, currentLang } = useLocales();
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Privacy Policy | Bil.Bio</title>
        <meta property="og:title" content="Privacy Policy | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={currentLang?.value} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <section className="-mt-[93px]  bg-[#fbf7f7] dark:bg-dark-primary pt-[93px]">
        <img
          className="absolute top-0 left-0 h-[22rem]"
          src={HeroEllipseGroup}
          alt=""
        />
        <div className="flex justify-center">
          <div className="2xl:max-w-screen-xl xl:max-w-screen-lg w-full">
            <div className="relative px-6 xsmfold:pt-12 pt-28 lg:pt-14 xl:pt-16">
              <div className="flex justify-center">
                <div className="text-center ">
                  <h1 className="text-custom_h5 dark:text-color_v1_dark xsmfold:text-custom_h4 sm:text-custom_h3 md:text-custom_h2 lg:text-custom_h1 mb-4 sm:mb-5">
                    {/* Privacy Policy */}
                    {translate("footer.privacy_policy")}
                  </h1>
                </div>
              </div>
              <div className="flex justify-center">
                <p className="mb-10 sm:mb-[86px] text-small1 sm:text-body_copy2 text-body_copy1_color dark:text-color_v2_dark text-center max-w-2xl">
                  {translate(
                    "front_end_pages.privacy_policy.lorem_ipsum_is_simply_dummy_text_of_the_printing"
                  )}
                  <span className="hidden sm:block">
                    {translate(
                      "front_end_pages.privacy_policy.lorem_ipsum_has_been_the_industry_standard_dummy_text"
                    )}
                  </span>
                </p>
              </div>
              <div className="flex justify-center items-center xsmfold:mb-7 mb-[80px] sm:mb-[150px]">
                <div className="max-w-4xl px-0 xsmfold:px-0 p-5 xsmfold:p-3 w-full">
                  <div className="mb-[24px] sm:mb-[43px] text-justify text-small2 smm:text-small1 sm:text-body_copy2 lg:text-body_copy1 text-body_copy_medium_color">
                    <h5 className="text-body_copy2_black smm:text-body_copy1_b sm:text-custom_h6 lg:text-custom_h5 mb-[12px] sm:mb-[17px] text-body_copy1_color dark:text-color_v1_dark">
                      {translate(
                        "front_end_pages.privacy_policy.what_is_lorem_ipsum"
                      )}
                    </h5>
                    <p className="dark:text-color_v2_dark">
                      {translate("front_end_pages.privacy_policy.first_para")}
                    </p>
                  </div>
                  <div className="mb-[24px] sm:mb-[43px] text-justify text-small2 smm:text-small1 sm:text-body_copy2 lg:text-body_copy1 text-body_copy_medium_color">
                    <h5 className="text-body_copy2_black sm:text-custom_h5  mb-[12px] sm:mb-[17px] text-body_copy1_color dark:text-color_v1_dark">
                      {translate(
                        "front_end_pages.privacy_policy.what_is_lorem_ipsum"
                      )}
                    </h5>
                    <p className="dark:text-color_v2_dark">
                      {translate("front_end_pages.privacy_policy.second_para")}
                    </p>
                    <ul className="marker:text-body_copy_medium_color dark:marker:text-color_v1_dark marker:text-small3 dark:text-color_v2_dark sm:marker:text-small2 ps-5 sm:ps-8 mt-5 sm:mt-8 list-outside list-disc">
                      <li className="list-item ps-1 sm:ps-3">
                        {translate("front_end_pages.privacy_policy.li_one")}
                      </li>
                      <li className="list-item ps-1 sm:ps-3">
                        {translate("front_end_pages.privacy_policy.li_two")}
                      </li>
                      <li className="list-item ps-1 sm:ps-3">
                        {translate("front_end_pages.privacy_policy.li_three")}
                      </li>
                      <li className="list-item ps-1 sm:ps-3">
                        {translate("front_end_pages.privacy_policy.li_four")}
                      </li>
                    </ul>
                  </div>

                  <div className="text-justify text-small2 smm:text-small1 sm:text-body_copy2 lg:text-body_copy1 text-body_copy_medium_color">
                    <h5 className="text-body_copy2_black smm:text-body_copy1_b sm:text-custom_h6 lg:text-custom_h5 mb-[12px] sm:mb-[17px] text-body_copy1_color dark:text-color_v1_dark">
                      {/* Why do we use it? */}
                      {translate(
                        "front_end_pages.privacy_policy.why_do_we_use_it"
                      )}
                    </h5>
                    <p className="dark:text-color_v2_dark">
                      {translate("front_end_pages.privacy_policy.last_para")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicyPage;
